<template lang="pug">
#app
  navigation#nav(
    @openLoginDialog="openLoginDialog",
    @alertNotLogin="alertNotLogin"
  )
  .main(:style="{ marginTop: $store.state.navHeight + 'px' }")
    transition(name="page", mode="out-in")
      router-view(:key="$route.path", @openLoginDialog="openLoginDialog")
  custom-dialog-login(
    v-if="loginDialogShow",
    @closeLoginDialog="closeLoginDialog",
    @successBack="successBack",
    @sendEmailSuccessBack="sendEmailSuccessBack"
  )
  dialog-success(
    v-if="successDialogShow",
    :title="successDialogTitle",
    :content="successDialogContent"
  )
  dialog-alert(
    v-if="alertDialogShow",
    :title="alertDialogTitle",
    :content="alertDialogContent"
  )
</template>

<script>
import navigation from "@/components/common/Navigation";
import CustomDialogLogin from "@/components/login/CustomDialogLogin";
import DialogSuccess from "@/components/login/DialogSuccess";
import DialogAlert from "@/components/login/DialogAlert";
import { stopScroll, startScroll } from "@/utils/scroll";
import "@/assets/style/main.scss";

export default {
  name: "App",
  components: {
    navigation,
    "custom-dialog-login": CustomDialogLogin,
    "dialog-success": DialogSuccess,
    "dialog-alert": DialogAlert,
  },
  data() {
    return {
      loginDialogShow: false,
      successDialogShow: false,
      successDialogTitle: "",
      successDialogContent: "",
      alertDialogShow: false,
      alertDialogTitle: "",
      alertDialogContent: "",
    };
  },
  mounted() {
    this.onResize();
    this.observeHeight();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function() {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    observeHeight() {
      var thiz = this;
      const resizeObserver = new ResizeObserver(function() {
        if (thiz.$store.state.screenWidth < 768) {
          thiz.$store.state.navHeight = 48;
        } else {
          thiz.$store.state.navHeight = document.getElementById(
            "nav"
          ).clientHeight;
        }
      });

      resizeObserver.observe(document.getElementById("nav"));
    },
    openLoginDialog() {
      this.loginDialogShow = true;
      stopScroll();
    },
    closeLoginDialog() {
      this.loginDialogShow = false;
      startScroll();
    },
    successBack() {
      this.loginDialogShow = false;
      this.successDialogShow = true;
      this.successDialogTitle = "登入成功";
      this.successDialogContent = "您已成功登入會員";
      setTimeout(() => {
        this.successDialogShow = false;
        this.successDialogTitle = "";
        this.successDialogContent = "";
        startScroll();
      }, 1500);
    },
    sendEmailSuccessBack() {
      this.loginDialogShow = false;
      this.successDialogShow = true;
      this.successDialogTitle = "信件已寄出";
      this.successDialogContent = "請至信箱確認修改密碼的信件";
      setTimeout(() => {
        this.successDialogShow = false;
        this.successDialogTitle = "";
        this.successDialogContent = "";
        startScroll();
      }, 1500);
    },
    alertNotLogin() {
      this.alertDialogShow = true;
      this.alertDialogTitle = "提醒";
      this.alertDialogContent = "請先登入會員";
      setTimeout(() => {
        this.alertDialogShow = false;
        this.alertDialogTitle = "";
        this.alertDialogContent = "";
        this.openLoginDialog();
      }, 1500);
    },
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "GlowSansTC";
  src: url(./assets/fonts/GlowSansTC-Normal-Regular.otf) format("opentype");
  font-weight: normal;
}
@font-face {
  font-family: "GlowSansTC";
  src: url(./assets/fonts/GlowSansTC-Normal-Bold.otf) format("opentype");
  font-weight: bold;
}
@font-face {
  font-family: "GlowSansTC";
  src: url(./assets/fonts/GlowSansTC-Normal-Thin.otf) format("opentype");
  font-weight: 300;
}
@font-face {
  font-family: "GlowSansTC";
  src: url(./assets/fonts/GlowSansTC-Normal-Medium.otf) format("opentype");
  font-weight: 500;
}
#app {
  display: flex;
  flex-direction: column;

  .main {
    position: relative;
  }
}
</style>
